import { render, staticRenderFns } from "./GenerateStaffTabReport.vue?vue&type=template&id=4b071780&"
import script from "./GenerateStaffTabReport.vue?vue&type=script&lang=ts&"
export * from "./GenerateStaffTabReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports